import { DataVariants } from "../../../data/DataManager";
import { GridFilterTypes } from "../../../grid/AgGridManager";
import { InputTypes } from "../../../form/FormManager";
import { EMPTY_VALUE, FieldSchema } from "../../../Schema";
import { LinkedInstance } from "../../common/external-sources/LinkedInstances";

export const network: FieldSchema = {
  grid: {
    displayed: true,
    order: 69,
    filter: GridFilterTypes.TEXT,
  },
  name: "network",
  data: {
    variant: DataVariants.ENUM,
    options: [
      "CoreLab",
      "Molecular",
      "Point of Care",
      "Pathology",
      "Sequencing",
    ],
    assignedValue: {
      getter: ({ network, linkedInstance }) => {
        if (!network && linkedInstance) {
          switch ((linkedInstance as LinkedInstance).linkedInstance) {
            case "Corelab SAP": {
              return "CoreLab";
            }
            case "RMD SAP": {
              return "Molecular";
            }
            default: {
              return EMPTY_VALUE;
            }
          }
        }
        return network;
      },
      fields: ["linkedInstance"],
    },
  },
  display: {
    displayed: true,
  },
  form: { label: "Network", type: InputTypes.SELECT },
};
